<template>
  <section class="vcenter">
    <form
      class="vcenter-form"
      @submit.prevent="submit"
    >

      <h1>Nouveau mot de passe</h1>

      <b-message
        v-if="errorMessage"
        type="is-danger"
      >
        {{ errorMessage }}
      </b-message>

      <b-field label="Mot de passe">
        <b-input
          v-model="password"
          type="password"
        />
      </b-field>

      <b-field label="Confirmer le mot de passe">
        <b-input
          v-model="password2"
          type="password"
        />
      </b-field>

      <div class="form-buttons">
        <button
          class="button is-primary"
          type="submit"
        >
          Valider
        </button>
        <div class="right">
          <router-link
            class="small"
            to="/"
          >
            Retour
          </router-link>
        </div>
      </div>

      <b-loading
        :active="loading"
        :is-full-page="false"
      />
    </form>
  </section>
</template>

<script>
export default {
  data () {
    return {
      password: '',
      password2: '',
      errorMessage: null,
      loading: false,
    }
  },
  methods: {
    async submit () {
      this.errorMessage = null
      if (this.password !== this.password2) {
        this.errorMessage = 'Les mots de passe ne correspondent pas'
        return
      }
      this.loading = true
      try {
        await this.$api.post('/login/password', {
          email: this.$route.query.email,
          token: this.$route.query.token,
          password: this.password,
        })
        this.$toast.open('Votre mot de passe a été mis à jour.')
        this.$router.push('/')
      } catch (e) {
        if (e.response && e.response.data && e.response.data.error) {
          this.errorMessage = e.response.data.error
        } else {
          this.errorMessage = e.message || 'Erreur lors de la connexion'
        }
      }
      this.loading = false
    },
  }
}
</script>
